export class Alert {
	constructor(
		//public activityid?: number,
		public name?: string,
		public before_activity_date?: string,
		public before_activity_time?: string,
		public sent?: boolean,
	) { }
}